<template>
  <div class="PageNotFound">
    <Picture name="page-not-found" />
    <h2 v-html="$t('errors.page-not-found/title')" />
    <p v-html="$t('errors.page-not-found/description')" />
    <Button @onClick="goToHome">
      {{ $t('errors.page-not-found/go-to-home') }}
    </Button>
  </div>
</template>

<script>
import { Button, Picture } from 'daas-components';

export default {
  name: 'PageNotFound',
  components: {
    Button,
    Picture,
  },

  methods: {
    goToHome() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss">
.PageNotFound {
  width: 100%;
  height: 50%;
  align-items: center;
  color: $primary;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: rem(150);
}
</style>
